function phoneValidator(value = '') {
  const { path, createError } = this

  if (!value || value.length === 0) {
    return true
  }

  const isValid = !!value && value.length !== 0 && value.match(/^\+\d{7,15}$/)

  return (
    isValid ||
    createError({
      path,
      message: 'common::validation_messages.incorrect_phone_format',
    })
  )
}

export default phoneValidator
